'use client';

import { useState } from 'react';
import { Image } from '@fshr/components';

import { cn } from '@fshr/shared-react';

interface BackgroundImageProps {
	src: string;
	className?: string;
}

export default function BackgroundImage({ src, className }: BackgroundImageProps) {
	return (
		<div className={cn('h-0 w-full pt-[33.33%] bg-neutral-100 relative', className)}>
			<div className="absolute top-0 left-0 right-0 bottom-0">
				<Image src={src} roughSize="l" alt="" className="h-full w-full object-cover" />
			</div>
		</div>
	);
}
